<template>
    <div :class="['options-wrapper', {'mobile-adapt': isCreamOn}]">
        <ul v-scroll="scrollParams[index]" class="level-wrapper" v-for="(levelData, index) in innerData" :key="index">
            <li
                v-if="levelSelect.multiple && levelSelect.showSelectTabAll && index === 0"
                class="option"
                :class="{'is-selected': allCount[0] && allCount[0] === allCount[1]}"
            >
                <el-checkbox
                    :value="allCount[0] && allCount[0] === allCount[1]"
                    :indeterminate="!!allCount[0] && allCount[0] !== allCount[1]"
                    @change="handleCheckAll"
                ></el-checkbox>
                <span>全选</span>
                <span class="count" v-if="levelSelect.multiple && levelSelect.showCount">
                    <span>(</span>
                    <span v-if="allCount[0]">{{allCount[0]}}/</span>
                    <span>{{allCount[1]}})</span>
                </span>
            </li>
            <li
                v-for="item in levelData"
                :key="item.id"
                class="option"
                :class="{
                    'is-active': index !== levelSelect.store.levelLength - 1 && activeOptions.includes(item.id),
                    'is-selected': isSelectedClass(item),
                    'is-disabled': isDisabledClass(item)
                }"
                @click="handleClickOption(item, index)"
            >
                <el-checkbox
                    v-if="levelSelect.multiple"
                    :key="item.id"
                    :value="judgeSelected(item)"
                    :indeterminate="!!item._selectedCount && !judgeSelected(item)"
                    :disabled="isDisabledClass(item)"
                    @change="(val) => handleCheck(val, item)"
                ></el-checkbox>
                <i v-else class="checked" :class="{'el-icon-check': item.checked }"></i>
                <level-label :data="item" :selected="judgeSelected(item)"></level-label>
                <span
                    class="count"
                    v-if="levelSelect.multiple && levelSelect.showCount && index !== innerData.length - 1"
                >
                    <span>(</span>
                    <span
                        v-if="item._selectedCount && levelSelect.multiple"
                    >{{item._selectedCount}}/</span>
                    <span>{{item._count}})</span>
                </span>
            </li>
        </ul>
        <div class="placeholder" v-if="!innerData.length">暂无数据</div>
    </div>
</template>
<script>
import { deepClone } from '@lsfe/tools';
import { findInTree } from '../model/utils';
import LevelLabel from './LevelLabel';

const initScrollParams = {
    offset: 0,
    limit: 20,
    end: 20
};

export default {
    inject: ['levelSelect'],
    components: {
        LevelLabel
    },
    data() {
        return {
            selected: [],
            allCount: [0, 0],
            canScrollUp: true,
            scrollParams: this.levelSelect.store.optionsData.map((levelData, index) => {
                const active = this.levelSelect.allLevelLazyLoad || index === this.levelSelect.store.optionsData.length - 1 || false;
                const params = {
                // el: '.option',
                    element: null,
                    ...initScrollParams,
                    active
                };
                params.handleScroll = this.handleScroll(params, levelData);
                return params;
            }),
        };
    },
    computed: {
        innerData() {
            const data = this.levelSelect.store.optionsData;
            if (!data || !data.length) {
                return [];
            }
            if(this.levelSelect.useScrollAllData){
                return data;
            }
            const length = data.length;
            const innerData = [];

            data.forEach((d, index) => {
                const {
                    offset,
                    end
                } = this.scrollParams[index] || {};
                innerData.push(
                    (this.levelSelect.allLevelLazyLoad || index === length - 1 || false) ? d.slice(offset, end) : d
                );
            });

            return innerData;
        },
        activeOptions() {
            // activeOptions变化，需要重置滚动位置
            this.scrollParams.forEach(scrollParam => {
                Object.keys(initScrollParams).forEach(prop => {
                    scrollParam[prop] = initScrollParams[prop];
                });
            });
            return this.levelSelect.store.activeOptions.map(item => item.id);
        },
        selectedPath() {
            const { store, multiple } = this.levelSelect;
            const selectedValues = Object.values(store.selectedValueMap);
            let value = selectedValues[0];
            // 多选和没有value时是不用的
            if (multiple || !value || (store.activeTab && !store.activeTab.filter(value))) {
                return [];
            }
            const path = [value.id];
            while (value && value._parentId) {
                value = findInTree(store.optData, value._parentId);
                if (value) {
                    path.unshift(value.id);
                }
            }
            return path;
        },
        isCreamOn() {
            return this.$mcCream && this.$mcCream.isCreamOn;
        },
    },
    watch: {
        'innerData.0': {
            handler(val) {
                const { multiple, showSelectTabAll } = this.levelSelect;
                if (multiple && showSelectTabAll) {
                    this.getAllCount(val || []);
                }
            },
            deep: true
        },
        'levelSelect.store.selectedValue': {
            handler() {
                const { multiple, showSelectTabAll, store } = this.levelSelect;
                if (multiple && showSelectTabAll && store.optionsData && store.optionsData.length === 1) {
                    // 一维数据监听
                    this.getAllCount(store.optionsData[0]);
                }
            }
        }
    },
    created() {
        const { multiple, showSelectTabAll } = this.levelSelect;
        if (multiple && showSelectTabAll) {
            this.getAllCount(this.levelSelect.store.optionsData[0] || []);
        }
    },
    methods: {
        isSelectedClass(data) {
            const { store, multiple } = this.levelSelect;
            if (!data.children) {
                return !!store.selectedValueMap[data.id];
            }
            if (multiple) {
                return data._selectedCount && data._selectedCount !== 0;
            }
            return this.selectedPath.includes(data.id);
        },
        isDisabledClass(data) {
            if (data.disabled || (data.children && data._count === data._disabledCount)) {
                return true;
            }
            return false;
        },
        judgeSelected(data) {
            const { store } = this.levelSelect;
            if (!data.children) {
                return !!store.selectedValueMap[data.id];
            }
            return data._selectedCount - (data._disabledSelectedCount || 0) === data._count - data._disabledCount;
        },
        handleClickOption(item, level) {
            const { store } = this.levelSelect;
            if (level === store.levelLength - 1) {
                // 选择门店
                if (this.levelSelect.multiple) {
                    return;
                }
                store.handleSelected(item);
                return this.levelSelect.emitChange();
            }
            // 切换父级菜单
            store.handleChangeActiveOpt(item, level);
        },
        handleCheck(val, item, emit = true) {
            const {maxSelectedCount, store} = this.levelSelect;
            if (
                val &&
                ((!item.children && store.selectedValue.length >= maxSelectedCount) ||
                (item.children && store.selectedValue.length + item._count - (item._selectedCount || 0) > maxSelectedCount))
            ) {
                return this.$message.warning(`选择失败，超出选择数量上限：${maxSelectedCount}`);
            }
            // emit控制是否抛出事件
            this.levelSelect.store.handleCheck(val, item);
            if (emit) {
                this.levelSelect.emitChange();
                this.levelSelect.emitCheck(deepClone(val, item));
            }
        },
        handleCheckAll(val) {
            const {maxSelectedCount} = this.levelSelect;
            if (val && this.allCount[1] > maxSelectedCount) {
                return this.$message.warning(`选择失败，超出选择数量上限：${maxSelectedCount}`);
            }
            // 执行对第一层的选中
            this.innerData[0].forEach(item => {
                this.handleCheck(val, item, false);
            });
            this.levelSelect.emitChange();
            this.levelSelect.emitCheck(val, deepClone(this.innerData[0]));
        },
        getAllCount(val) {
            const {optionsData} = this.levelSelect.store;
            if (optionsData && optionsData.length === 1) {
                // 一维的
                return this.allCount = [this.levelSelect.store.selectedValue.length, val.length];
            }
            // [全部选中数量, 选项数量]
            this.allCount = val.reduce(
                (prev, cur) => {
                    return [prev[0] + (cur._selectedCount || 0), prev[1] + (cur._count || 0)];
                },
                [0, 0]
            );
        },
        handleScroll(params, levelData) {
            return (el, position) => {
                params.element = el;
                let { offset, limit } = params;
                // let limmitDistance = el.scrollHeight / 6; // 设置距离边缘的距离
                let limmitDistance = 100; // 设置距离边缘的距离
                let scrollTo = el.scrollTop - position < 0 ? 'up' : 'down';
                let resetScrollTop = false; // 定义重置scrollTop的控制器
                // const length = this.levelSelect.store.optionsData.length;
                const data = levelData;
                if (scrollTo === 'up') {
                    // canScrollUp用来防止滚动条下移的过程中的scrollTop位置变更,如果不做控制会存在下移过程中重置scrollTop导致up事件触发
                    if (!this.canScrollUp) {
                        return (this.canScrollUp = true);
                    }
                    // 滚动条上移
                    if (el.scrollTop <= limmitDistance) {
                        // 如果是加在的第一项，不操作
                        if (offset <= 0) {
                            return;
                        }
                        // 控制offset最小为0
                        if (offset < limit) {
                            params.offset = 0;
                        } else {
                            params.offset -= limit;
                        }
                        // 计算偏移量
                        // const scrollLen = offset - this.scrollParams.offset;
                        // 超出渲染的下拉项数量限制，scrollEnd变化
                        if (params.end - params.offset > 3 * limit) {
                            params.end = params.offset + 3 * limit;
                            resetScrollTop = true;
                        }
                    }
                } else if (scrollTo === 'down') {
                    // 滚动条下移
                    if (el.scrollTop + el.clientHeight + limmitDistance >= el.scrollHeight) {
                        // 如果现在是加载最后一项，不操作
                        if (params.end >= data.length) {
                            return;
                        }
                        // 否则进行移动
                        if (params.end + limit > data.length) {
                            params.end = data.length;
                        } else {
                            params.end += limit;
                        }
                        if (params.end - params.offset > 3 * limit) {
                            // 超出渲染的下拉项数量限制
                            // 记录一下offset的距离 用来计算抵消越变的滚动距离
                            params.offset = params.end - 3 * limit + 1;
                            offset = params.offset - offset - 1;
                            resetScrollTop = true;
                        }
                        if (resetScrollTop && params.active) {
                            this.canScrollUp = false;
                            // 处理越变
                            el.scrollTop = el.scrollTop - offset * (el.scrollHeight / (3 * limit));
                        }

                    }
                }
            };
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../../styles/common/var.scss';

.options-wrapper {
    display: flex;
    position: relative;
    height: 200px;
    .level-wrapper {
        width: 180px;
        height: 100%;
        overflow-y: auto;
        font-size: 12px;
        list-style-type: none;
        padding: 0;
        margin: 0;
        & + .level-wrapper {
            border-left: 1px solid #dcdfe6;
        }
        .option {
            cursor: pointer;
            padding: 2px 10px;
            box-sizing: border-box;
            display: flex;
            line-height: 14px;
            .el-checkbox {
                margin-right: 4px;
            }
            &.is-active {
                background-color: #f5f7fa;
                font-weight: 500;
            }
            &.is-disabled {
                color: #c0c4cc;
            }
            &.is-selected {
                color: $--color-primary;
            }
            &:hover {
                background-color: #f5f7fa;
                overflow: visible;
            }
            .checked {
                display: inline-block;
            }
            .count {
                font-size: 0;
                span {
                    font-size: 13px;
                }
            }
        }
    }
    .placeholder {
        width: 100px;
        height: 14px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        text-align: center;
    }
    &.mobile-adapt {
      height: 300px;
    }
}
</style>
